import * as net from 'util/Net';

export type TimelineRange = '4h' | '1d' | '1w';

export type TimelineTurnState = 'complete' | 'in_flight' | 'no_response';

export interface TimelineAgentResponse {
  agentId: string;
  /** Null when the agent no longer exists; the foundry still has a slot for it. */
  name: string | null;
  isCoordinator: boolean;
}

export interface TimelineTurnResponse {
  agentId: string;
  chatSessionId: string;
  chatName: string | null;
  requestEventId: string;
  /** ISO 8601 timestamps. `endedAt` is null for a turn that is in flight or never got a response. */
  startedAt: string;
  endedAt: string | null;
  state: TimelineTurnState;
}

export interface AgentFoundryTimelineResponse {
  windowStart: string;
  windowEnd: string;
  /** The Coordinator first (if set), then the assigned agents in the foundry's order. */
  agents: Array<TimelineAgentResponse>;
  turns: Array<TimelineTurnResponse>;
  /** True when the window held more turns than `maxTurns` and only the newest are returned. */
  truncated: boolean;
  maxTurns: number;
}

export function getAgentFoundryTimeline(
  agentFoundryId: string,
  range: TimelineRange
): Promise<AgentFoundryTimelineResponse> {
  return net.postJSONPromise({
    url: `/1/api/llm/agent-foundries/${agentFoundryId}:timeline`,
    data: {range},
  });
}
